export default "<p>\n  search works!\n</p>\n";